import { ShareButtons } from 'react-share';

const {
      FacebookShareButton,
      TwitterShareButton,
      WhatsappShareButton,
      PinterestShareButton,
    } = ShareButtons;

const buttonConfig = [
 {
  SocialButton: FacebookShareButton,
  icon: 'facebook'
 },
 {
  SocialButton: TwitterShareButton,
  icon: 'twitter'
 },
 {
  SocialButton: WhatsappShareButton,
  icon: 'whatsapp'
 },
 {
  SocialButton: PinterestShareButton,
  extraProps: {
    media: 'https://raw.githubusercontent.com/MindMakersProject/website-BE/master/photos/Taste%20Of%20Stem/tastebud_1.0.jpeg'
  },
  icon: 'pinterest'
 },
]

export default buttonConfig



// WEBPACK FOOTER //
// ./src/configs/social-config.js